import { render, staticRenderFns } from "./user-data-analysis.vue?vue&type=template&id=5cf2d530&scoped=true&"
import script from "./user-data-analysis.vue?vue&type=script&lang=js&"
export * from "./user-data-analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2d530",
  null
  
)

export default component.exports